module.exports = __webpack_public_path__ + "static/media/shocase.d9902406.png";